import {Button, Grid, TextField} from '@material-ui/core';
import React, { useCallback, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ReactComponent as LogoWithTextSVG } from '~/assets/img/logo-with-text.svg';
import css from './styles.module.scss';

interface SignUpFormProps {
    action: (p: { email: string; password: string }) => Promise<any>;
}

export const SignUpForm: React.FC<SignUpFormProps> = ({ action }) => {
    const { handleSubmit, register, errors } = useForm();

    const [isSigning, setSigning] = useState(false);

    const onSubmit = useCallback(
        async (data: { email: string; password: string }) => {
            setSigning(true);
            await action(data);
            setSigning(false);
        },
        [action]
    );

    const formSubmit = useMemo(() => handleSubmit(onSubmit), [handleSubmit, onSubmit]);

    return (
        <div className={css.module}>
            <LogoWithTextSVG className={css.logo} />
            <form className={css.form} onSubmit={formSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <TextField
                            name={'firstName'}
                            label={'First Name'}
                            inputRef={register({ required: 'First Name is required' })}
                            fullWidth
                            type={'firstName'}
                            autoFocus
                        />
                        <p className={css.error}>{errors.firstName?.message}</p>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            name={'lastName'}
                            label={'Last Name'}
                            inputRef={register({ required: 'Last Name is required' })}
                            fullWidth
                            type={'lastName'}
                            autoFocus
                        />
                        <p className={css.error}>{errors.lastName?.message}</p>
                    </Grid>
                </Grid>
                <TextField
                    name={'phone'}
                    label={'Phone'}
                    inputRef={register({ required: 'Phone is required' })}
                    fullWidth
                    type={'phone'}
                    autoFocus
                />
                <p className={css.error}>{errors.phone?.message}</p>
                <TextField
                    name={'email'}
                    label={'Email'}
                    inputRef={register({ required: 'Email is required' })}
                    fullWidth
                    type={'email'}
                    autoFocus
                />
                <p className={css.error}>{errors.email?.message}</p>
                <TextField
                    name={'password'}
                    label={'Password'}
                    inputRef={register({ required: 'Password is required' })}
                    fullWidth
                    type={'password'}
                    autoFocus
                />
                <p className={css.error}>{errors.password?.message}</p>
                <TextField
                    name={'passwordConfirm'}
                    label={'Password confirmation'}
                    inputRef={register({ required: 'Password confirmation is required' })}
                    fullWidth
                    type={'passwordConfirm'}
                    autoFocus
                />
                <p className={css.error}>{errors.passwordConfirm?.message}</p>
                <Button className={css.submitButton} type={'submit'} disabled={isSigning} fullWidth>
                    Sign up
                </Button>
            </form>
        </div>
    );
};
